module.exports = __webpack_public_path__ + "img/top2.7ecd1448.png";